<template>
  <div v-loading="contentLoading">
    <div class="title">
      基本信息
    </div>
    <table cellspacing="0" cellpadding="0" style="width: 100%" class="ReserveOrderTable">
      <tr>
        <td class="tableLabel">申请编号</td>
        <td class="tableContent">{{form.invoiceApplicationNo}}</td>
        <td class="tableLabel">申请状态</td>
        <td class="tableContent">
          <span v-if="form.status===0">草稿</span>
          <span v-if="form.status===1">已提交</span>
          <span v-if="form.status===2">已处理</span>
        </td>
        <td class="tableLabel">标识</td>
        <td class="tableContent">{{form.sign}}</td>
      </tr>
      <tr>
        <td class="tableLabel">客户名称</td>
        <td class="tableContent">{{form.customerName}}</td>
        <td class="tableLabel">客户税号</td>
        <td class="tableContent">{{form.invoiceVATNO}}</td>
        <td class="tableLabel">银行账号</td>
        <td class="tableContent">{{form.invoiceAccounts}}</td>
      </tr>
      <tr>
        <td class="tableLabel">客户编号</td>
        <td class="tableContent">{{form.customerNo}}</td>
        <td class="tableLabel">地址</td>
        <td class="tableContent">{{form.invoiceAddress}}</td>
        <td class="tableLabel">邮箱</td>
        <td class="tableContent">{{form.email}}</td>
      </tr>
      <tr>
        <td class="tableLabel">备注</td>
        <td class="tableContent">{{form.note}}</td>
        <td class="tableLabel">申请人</td>
        <td class="tableContent">{{form.creatorName}}</td>
        <td class="tableLabel"/>
        <td class="tableContent"/>
      </tr>
      <tr>
        <td class="tableLabel">申请日期</td>
        <td class="tableContent">{{form.createTime}}</td>
        <td class="tableLabel">提交日期</td>
        <td class="tableContent">{{form.submitTime}}</td>
        <td class="tableLabel">通过日期</td>
        <td class="tableContent">{{form.passTime}}</td>
      </tr>
      <tr>
        <td class="tableLabel">开票不含税金额</td>
        <td class="tableContent">{{form.totalNetPrice}}</td>
        <td class="tableLabel">税额</td>
        <td class="tableContent">{{form.totalTaxPrice}}</td>
        <td class="tableLabel">开票金额</td>
        <td class="tableContent">{{form.invoiceTotalAmount}}</td>
      </tr>
    </table>
    <div>
      <el-button
          style="margin-top: 10px"
          :disabled="deliverySelection.length === 0 && saleOrderSelection.length === 0"
          type="primary"
          @click="addSapInvoice">
        明细开票
      </el-button>
      <el-button
          :disabled="deliverySelection.length === 0 && saleOrderSelection.length === 0"
          type="primary"
          @click="countSapInvoice">
        汇总开票
      </el-button>
      <div
          style="border-bottom: 1px solid #ddd; margin-bottom: 10px; padding-bottom: 5px; font-size: 16px; margin-top: 20px">
        关联发货单列表
      </div>
      <el-table
          :data="deliveryList"
          :border="true"
          stripe
          @select="deliverySelectHandle"
          @select-all="deliverySelectHandle">
        <el-table-column type="selection" align="center" width="55"/>
        <el-table-column type="index" align="center" label="#"/>
        <el-table-column prop="billNo" align="center" label="单号" width="100"/>
        <el-table-column prop="rowIndex" align="center" label="行项" width="100"/>
        <el-table-column prop="materialNo" align="center" label="物料号" width="100"/>
        <el-table-column prop="materialName" align="center" label="物料名称" width="400"/>
        <el-table-column prop="quantity" align="center" label="数量" width="100"/>
        <el-table-column prop="unitPrice" align="center" label="单价(含税)" width="100"/>
        <el-table-column prop="totalPrice" align="center" label="总价(含税)" width="100"/>
      </el-table>
      <div
          v-if="saleOrderList.length"
          style="border-bottom: 1px solid #ddd; margin-bottom: 10px; padding-bottom: 5px; font-size: 16px; margin-top: 20px">
        关联销售订单列表
      </div>
      <el-table
          v-if="saleOrderList.length"
          :data="saleOrderList"
          :border="true"
          stripe
          @select="saleOrderSelectHandle"
          @select-all="saleOrderSelectHandle">
        <el-table-column type="selection" align="center" width="55"/>
        <el-table-column type="index" align="center" label="#"/>
        <el-table-column prop="billNo" align="center" label="单号"/>
        <el-table-column prop="rowIndex" align="center" label="行项"/>
        <el-table-column prop="materialNo" align="center" label="物料号"/>
        <el-table-column prop="materialName" align="center" label="物料名称"/>
        <el-table-column prop="quantity" align="center" label="数量"/>
        <el-table-column prop="unit" align="center" label="单位"/>
        <el-table-column prop="unitPrice" align="center" label="单价(含税)"/>
        <el-table-column prop="totalPrice" align="center" label="总价(含税)"/>
      </el-table>
    </div>
    <div
        style="border-bottom: 1px solid #ddd; margin-bottom: 10px; padding-bottom: 5px; font-size: 16px; margin-top: 20px; display: flex; flex-direction: row; align-items: center; justify-content: space-between">
      <div>开票信息</div>
      <div>总金额：￥{{form.invoiceTotalAmount}}</div>
    </div>
<!--    <el-button type="primary" style="margin-bottom: 5px" @click="addFinancialDetails">添加</el-button>-->
    <div>
      <el-table
          :data="form.details"
          :border="true"
          stripe>
<!--        <el-table-column fixed="left" type="expand">-->
<!--          <template slot-scope="props">-->
<!--            <el-table-->
<!--                :data="props.row.deliveryList"-->
<!--                style="width: 100%;margin: 0 auto">-->
<!--              <el-table-column type="index" align="center" label="行项"/>-->
<!--              <el-table-column prop="billNo" align="center" label="单号"/>-->
<!--              <el-table-column prop="materialNo" align="center" label="物料编号"/>-->
<!--              <el-table-column prop="materialName" width="220" align="center" label="物料描述"/>-->
<!--              <el-table-column prop="specification" align="center" label="规格型号"/>-->
<!--              <el-table-column prop="unit" align="center" label="单位"/>-->
<!--              <el-table-column prop="quantity" align="center" label="数量"/>-->
<!--              <el-table-column prop="unitPrice" align="center" label="开票单价"/>-->
<!--              <el-table-column prop="totalPrice" align="center" label="开票总额"/>-->
<!--              <el-table-column prop="note" align="center" label="备注"/>-->
<!--            </el-table>-->
<!--            <el-table-->
<!--                :data="props.row.saleOrderList"-->
<!--                style="width: 100%;margin: 0 auto">-->
<!--              <el-table-column type="index" align="center" label="行项"/>-->
<!--              <el-table-column prop="billNo" align="center" label="单号"/>-->
<!--              <el-table-column prop="materialNo" align="center" label="物料编号"/>-->
<!--              <el-table-column prop="materialName" width="220" align="center" label="物料描述"/>-->
<!--              <el-table-column prop="specification" align="center" label="规格型号"/>-->
<!--              <el-table-column prop="unit" align="center" label="单位"/>-->
<!--              <el-table-column prop="quantity" align="center" label="数量">-->
<!--                <template slot-scope="scope">-->
<!--                  <el-input v-model="scope.row.quantity" placeholder="数量" @change="handleTypeChange(scope.row)"/>-->
<!--                </template>-->
<!--              </el-table-column>-->
<!--              <el-table-column prop="unitPrice" align="center" label="开票单价"/>-->
<!--              <el-table-column prop="totalPrice" align="center" label="开票总额"/>-->
<!--              <el-table-column prop="note" align="center" label="备注"/>-->
<!--            </el-table>-->
<!--            <el-table-->
<!--                :data="props.row.countList"-->
<!--                style="width: 100%;margin: 0 auto">-->
<!--              <el-table-column type="index" align="center" label="行项"/>-->
<!--              <el-table-column prop="billNo" align="center" label="单号"/>-->
<!--              <el-table-column prop="materialNo" align="center" label="物料编号"/>-->
<!--              <el-table-column prop="materialName" width="220" align="center" label="物料描述"/>-->
<!--              <el-table-column prop="specification" align="center" label="规格型号"/>-->
<!--              <el-table-column prop="unit" align="center" label="单位"/>-->
<!--              <el-table-column prop="quantity" align="center" label="数量">-->
<!--                <template slot-scope="scope">-->
<!--                  <el-input v-model="scope.row.quantity" placeholder="数量" @change="handleTypeChange(scope.row)"/>-->
<!--                </template>-->
<!--              </el-table-column>-->
<!--              <el-table-column prop="unitPrice" align="center" label="开票单价"/>-->
<!--              <el-table-column prop="totalPrice" align="center" label="开票总额"/>-->
<!--              <el-table-column prop="note" align="center" label="备注"/>-->
<!--            </el-table>-->
<!--          </template>-->
<!--        </el-table-column>-->
        <el-table-column type="index" align="center" label="行项"/>
        <el-table-column prop="invoiceContent" align="center" label="开票名称" width="200">
          <template slot-scope="scope">
            <el-input
                v-model="scope.row.invoiceContent"
                :disabled="!edit"
                placeholder="请输入开票名称"/>
          </template>
        </el-table-column>
        <el-table-column prop="materialNo" align="center" label="物料编号" width="200">
          <template slot-scope="scope">
            <el-input v-model="scope.row.materialNo" :disabled="!edit" placeholder="请输入物料编号"/>
          </template>
        </el-table-column>
        <el-table-column prop="materialName" width="200" align="center" label="物料描述">
          <template slot-scope="scope">
            <el-input
                v-model="scope.row.materialName"
                autosize
                :disabled="!edit"
                placeholder="请输入物料描述"/>
          </template>
        </el-table-column>
        <el-table-column prop="specification" align="center" label="规格型号" width="300">
          <template slot-scope="scope">
            <el-input
                v-model="scope.row.specification"
                autosize
                :disabled="!edit"
                placeholder="请输入规格型号"/>
          </template>
        </el-table-column>
        <el-table-column prop="unit" align="center" label="单位" width="100">
          <template slot-scope="scope">
            <el-input v-model="scope.row.unit" :disabled="!edit" placeholder="请输入单位"/>
          </template>
        </el-table-column>
        <el-table-column prop="quantity" align="center" label="数量" width="100">
          <template slot-scope="scope">
            <el-input
                v-model="scope.row.quantity"
                :disabled="!edit"
                placeholder="请输入数量"
                @change="handleTypeChange(scope.row)"/>
          </template>
        </el-table-column>
        <el-table-column prop="unitPrice" align="center" label="开票单价" width="100">
          <template slot-scope="scope">
            <el-input v-model="scope.row.unitPrice" :disabled="!edit" placeholder="请输入开票单价"/>
          </template>
        </el-table-column>
        <el-table-column prop="totalPrice" align="center" label="开票总额" width="100">
          <template slot-scope="scope">
            <el-input v-model="scope.row.totalPrice" :disabled="!edit" placeholder="请输入开票总额"/>
          </template>
        </el-table-column>
        <el-table-column prop="totalTaxPrice" align="center" label="税额" width="100"/>
        <el-table-column prop="totalNetPrice" align="center" label="不含税金额" width="100"/>
        <el-table-column prop="taxRate" align="center" label="税率" width="100"/>
        <el-table-column prop="taxTypeCode" align="center" label="税收分类编码" width="100"/>
        <el-table-column prop="taxTypeName" align="center" label="税收分类描述" width="100"/>
        <el-table-column prop="note" align="center" label="备注" width="200">
          <template slot-scope="scope">
            <el-input
                v-model="scope.row.note"
                type="textarea"
                autosize
                :disabled="!edit"
                placeholder="请输入备注"/>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="100" align="center">
          <template slot-scope="scope">
            <el-button :disabled="!edit" type="primary" @click="deleteRow(scope.$index,scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div>
      <div
          style="border-bottom: 1px solid #ddd; margin-bottom: 10px; padding-bottom: 5px; font-size: 16px; margin-top: 20px">
        订单附件
      </div>
      <div>
        <el-upload
            action=""
            multiple
            :http-request="submitUpload"
            :show-file-list="false"
            :disabled="uploadLoading"
            style="display: inline-block; float: left; margin: 5px;">
          <el-button type="primary" :disabled="!edit">
            <i class="el-icon-upload el-icon--right"/>
            附件上传
          </el-button>
        </el-upload>
      </div>
      <el-table ref="payData1" border :data="form.accessoryList">
        <el-table-column type="index" align="center" label="#" width="55"/>
        <el-table-column prop="fileName" align="left" label="附件描述" width="750"/>
        <el-table-column label="下载" width="70" align="center">
          <template slot-scope="scope">
            <el-button type="primary" @click="download(scope.row)">下载</el-button>
          </template>
        </el-table-column>
        <el-table-column prop="note" align="center" label="备注" show-overflow-tooltip/>
      </el-table>
    </div>
    <div style="text-align: right">
      <span v-if="edit" slot="footer" class="dialog-footer">
        <el-button type="primary" :loading="submitLoading" @click="saveHandle">保存</el-button>
        <!--        <el-button type="primary" :loading="submitLoading" @click="submit">提交</el-button>-->
      </span>
    </div>
  </div>
</template>

<script>


  import loginUtil from "@/util/loginUtil";

  export default {
    name: "InvoiceApplicationPreview",
    components: {},
    data() {
      return {
        downLoadLoading: false,
        deliverySelection: [],
        saleOrderSelection: [],
        contentLoading: false,
        pkid: "",
        dialogVisible: false,
        submitLoading: false,
        uploadLoading: false,
        edit: 0,
        form: {
          pkId: 0,
          billNo: "",
          customerId: "",
          customerName: "",
          customerNo: "",
          invoiceVATNO: "",
          invoiceAddress: "",
          invoiceAccounts: "",
          financialVouchers: "",
          email: "",
          sign: "财务",
          invoiceTotalAmount: "",
          note: "",
          details: [],
        },
        deliveryList: [],
        saleOrderList: [],
        initDeliveryList: [],
        initSaleOrderList: [],
        ruleValidate: {},
        isShowDetail: true,
        finalData: [],
        tempTableData: [],
        tableData: [],
      };
    },

    watch: {
      $route: {
        handler: function(val) {
          if (val.name === "InvoiceApplicationPreview") {
            this.getData(this.$route.query.billId, this.$route.query.selection);
          }
        },
      },
    },
    mounted() {
      this.$nextTick(() => {
        this.getData(this.$route.query.billId, this.$route.query.selection);
      },
      );
    },

    methods: {
      addSapInvoice() {
        if (this.deliverySelection.length > 0) {
          this.deliverySelection.forEach((item) => {
            this.form.details.push({
              invoiceContent: "",
              materialNo: item.materialNo,
              materialName: item.materialName,
              specification: item.specification,
              unit: item.unit,
              quantity: item.quantity,
              unitPrice: item.unitPrice,
              totalPrice: item.quantity * item.unitPrice,
              note: "",
              rowIndex: item.rowIndex,
              type: "发货单",
              deliveryBillId: item.deliveryBillId,
              deliveryDetailId: item.deliveryDetailId,
              billNo: item.billNo,
              deliveryList: [{
                invoiceContent: "",
                materialNo: item.materialNo,
                materialName: item.materialName,
                specification: item.specification,
                unit: item.unit,
                quantity: item.quantity,
                unitPrice: item.unitPrice,
                totalPrice: item.totalPrice,
                sapSaleOrderNo: item.sapSaleOrderNo,
                salesOrderRowIndex: item.salesOrderRowIndex,
                note: "",
                rowIndex: item.rowIndex,
                type: "发货单",
                deliveryBillId: item.deliveryBillId,
                deliveryDetailId: item.deliveryDetailId,
                billNo: item.billNo,
              }],
            });
          });
          this.deliverySelection.forEach((item) => {
            this.deliveryList.splice(this.deliveryList.findIndex((item2) => item2.deliveryBillId === item.deliveryBillId), 1);
          });
        }
        if (this.saleOrderSelection.length > 0) {
          this.saleOrderSelection.forEach((item) => {
            this.form.details.push({
              invoiceContent: "",
              materialNo: item.materialNo,
              materialName: item.materialName,
              specification: item.specification,
              unit: item.unit,
              quantity: item.quantity,
              unitPrice: item.unitPrice,
              totalPrice: item.quantity * item.unitPrice,
              note: "",
              rowIndex: item.rowIndex,
              type: "销售订单",
              billNo: item.billNo,
              saleOrderId: item.saleOrderId,
              saleOrderList: [{
                invoiceContent: "",
                materialNo: item.materialNo,
                materialName: item.materialName,
                specification: item.specification,
                unit: item.unit,
                quantity: item.quantity,
                unitPrice: item.unitPrice,
                totalPrice: item.totalPrice,
                sapSaleOrderNo: item.sapSaleOrderNo,
                salesOrderRowIndex: item.salesOrderRowIndex,
                note: "",
                rowIndex: item.rowIndex,
                type: "销售订单",
                saleOrderId: item.saleOrderId,
                billNo: item.billNo,
              }],
            });
          });
          this.saleOrderSelection.forEach((item) => {
            this.saleOrderList.splice(this.saleOrderList.findIndex((item2) => item2.saleOrderId === item.saleOrderId), 1);
          });
        }
      },
      countSapInvoice() {
        let allList = this.deliverySelection.concat(this.saleOrderSelection);
        let model = allList[0];
        if (allList.length > 0) {
          let params = {
            invoiceContent: "",
            materialNo: model.materialNo,
            materialName: model.materialName,
            specification: model.specification,
            unit: model.unit,
            quantity: 1,
            unitPrice: "",
            totalPrice: "",
            note: "",
            parentId: "",
            type: "汇总",
          };
          let countList = [];
          let initUnitPrice = 0;
          allList.forEach((item) => {
            initUnitPrice += parseFloat(item.totalPrice);
            if (item.billNo.includes("31")) {
              countList.push({
                invoiceContent: "",
                materialNo: item.materialNo,
                materialName: item.materialName,
                specification: item.specification,
                unit: item.unit,
                quantity: item.quantity,
                unitPrice: item.unitPrice,
                totalPrice: item.quantity * item.unitPrice,
                note: "",
                rowIndex: item.rowIndex,
                type: "销售订单",
                billNo: item.billNo,
                saleOrderId: item.saleOrderId,
              });
            } else {
              countList.push({
                invoiceContent: "",
                materialNo: item.materialNo,
                materialName: item.materialName,
                specification: item.specification,
                unit: item.unit,
                quantity: item.quantity,
                unitPrice: item.unitPrice,
                totalPrice: item.quantity * item.unitPrice,
                note: "",
                rowIndex: item.rowIndex,
                type: "发货单",
                deliveryBillId: item.deliveryBillId,
                sapSaleOrderNo: item.sapSaleOrderNo,
                salesOrderRowIndex: item.salesOrderRowIndex,
                billNo: item.billNo,
                deliveryDetailId: item.deliveryDetailId,
              });
            }

          });
          if (initUnitPrice > 0) {
            params.totalPrice = initUnitPrice;
            params.unitPrice = initUnitPrice;
          }
          params.countList = countList;
          this.form.details.push(params);
          console.log(this.form.details);
          countList.forEach((item) => {
            if (item.billNo.includes("31")) {
              this.saleOrderList.splice(this.saleOrderList.findIndex((item2) => item2.saleOrderId === item.saleOrderId), 1);
            } else {
              this.deliveryList.splice(this.deliveryList.findIndex((item2) => item2.deliveryBillId === item.deliveryBillId), 1);
            }
          });
        }
      },
      deleteRow(index, row) {
        console.log(row);
        if (row.type === "发货单") {
          let params = {
            billNo: row.billNo,
            rowIndex: row.rowIndex,
            materialNo: row.materialNo,
            materialName: row.materialName,
            unit: row.unit,
            quantity: row.quantity,
            unitPrice: row.unitPrice,
            totalPrice: row.totalPrice,
            deliveryBillId: row.deliveryBillId,
            sapSaleOrderNo: row.sapSaleOrderNo,
            salesOrderRowIndex: row.salesOrderRowIndex,
          };
          this.deliveryList.push(params);
        } else if (row.type === "销售订单") {
          let params = {
            billNo: row.billNo,
            rowIndex: row.rowIndex,
            materialNo: row.materialNo,
            materialName: row.materialName,
            unit: row.unit,
            quantity: row.quantity,
            unitPrice: row.unitPrice,
            totalPrice: row.totalPrice,
            saleOrderId: row.saleOrderId,
          };
          this.saleOrderList.push(params);
        } else {
          console.log(row.countList);
          row.countList.forEach((item) => {
            if (item.billNo.includes("31")) {
              let params = {
                billNo: item.billNo,
                rowIndex: item.rowIndex,
                materialNo: item.materialNo,
                materialName: item.materialName,
                unit: item.unit,
                quantity: item.quantity,
                unitPrice: item.unitPrice,
                totalPrice: item.totalPrice,
                saleOrderId: item.saleOrderId,
              };
              this.saleOrderList.push(params);
            } else {
              let params = {
                billNo: item.billNo,
                rowIndex: item.rowIndex,
                materialNo: item.materialNo,
                materialName: item.materialName,
                unit: item.unit,
                quantity: item.quantity,
                unitPrice: item.unitPrice,
                totalPrice: item.totalPrice,
                deliveryBillId: item.deliveryBillId,
                sapSaleOrderNo: item.sapSaleOrderNo,
                salesOrderRowIndex: item.salesOrderRowIndex,
              };
              this.deliveryList.push(params);
            }
          });
        }
        this.form.details.splice(index, 1);
      },
      deleteRowByFinancial(index) {
        this.form.details.splice(index, 1);
      },
      getData(id, selection) {
        if (id > 0) {
          this.$http.get("basic", "invoiceApplication/" + id).then((resp) => {
            this.form = resp;
            this.deliveryList = JSON.parse(JSON.stringify(resp.deliveryList));
            this.saleOrderList = JSON.parse(JSON.stringify(resp.saleOrderList));
            if (this.form.details.length > 0) {
              this.form.details.forEach((item) => {
                item.countList = item.deliveryList.concat(item.saleOrderList);
                item.totalPrice = item.quantity * item.unitPrice;
              });
            }
          });
        } else {
          this.edit = 1;
          if (selection.length > 0) {
            this.$http.post("basic", "invoiceApplications/getDetails", selection).then((resp) => {
              this.form = resp;
              this.deliveryList = JSON.parse(JSON.stringify(resp.deliveryList));
              this.saleOrderList = JSON.parse(JSON.stringify(resp.saleOrderList));
            }).catch(() => {
              this.$router.push({
                path: "/SalesManage/InvoiceApplication/ToDoInvoiceList",
              });
              //关闭当前标签
              this.$bus.$emit("closeTag", this.$route);
            });
          }
        }
      },
      deliverySelectHandle(selection) {
        this.deliverySelection = selection;
      },
      saleOrderSelectHandle(selection) {
        this.saleOrderSelection = selection;
      },
      download(row) {
        let data = {
          name: row.fileName,
          uuid: row.filePath,
        };
        this.$http.exportFile("basic", "file/download", data).then(res => {
          console.log(res);
          let blob = new Blob([res.data], {type: "application"});
          let fileName = decodeURI(res.config.params.name);
          if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            navigator.msSaveBlob(blob, fileName);
          } else {
            let a = document.createElement("a");
            a.href = URL.createObjectURL(blob);
            a.download = fileName;
            a.style.display = "none";
            document.body.appendChild(a);
            a.click();
            URL.revokeObjectURL(a.href);
            document.body.removeChild(a);
          }
        });
      },
      submitUpload(params) {
        this.uploadLoading = true;
        let formData = new FormData(); //  用FormData存放上传文件
        formData.append("file", params.file);
        formData.append("Authorization", loginUtil.getToken());
        this.$http
          .post("basic", "file/upload", formData)
          .then((res) => {
            this.uploadLoading = false;
            console.log(res);
            this.form.accessoryList.push({
              fileName: res.originalName,
              filePath: res.fullPath,
              note: "",
            });
            this.$message.success("上传成功");
          })
          .catch(() => {
            this.uploadLoading = false;
            this.$message.error("上传失败");
          });
      },
      saveHandle() {
        // if (!this.form.customerName) {
        //   return this.$message.error("请选择客户！");
        // }
        // if (!this.form.invoiceVATNO) {
        //   return this.$message.error("请填写客户税号！");
        // }
        // if (!this.form.invoiceAccounts) {
        //   return this.$message.error("请填写银行账号！");
        // }
        // if (!this.form.financialVouchers) {
        //   return this.$message.error("请填写财务凭证号！");
        // }
        let isNext = true;
        let message = "";
        if (this.form.details.length <= 0) {
          return this.$message.error("开票信息不能为空！");
        } else {
          this.form.details.forEach(item => {
            if (item.invoiceContent === "") {
              message = "开票名称不能为空！";
              isNext = false;
            } else if (item.materialNo === "") {
              message = "物料编号不能为空！";
              isNext = false;
            } else if (item.specification === "") {
              message = "规格型号不能为空！";
              isNext = false;
            } else if (item.unit === "") {
              isNext = false;
              message = "单位不能为空！";
            } else if (item.quantity === "") {
              isNext = false;
              message = "数量不能为空！";
            } else if (item.unitPrice === "") {
              isNext = false;
              message = "开票单价不能为空！";
            } else if (item.totalPrice === "") {
              isNext = false;
              message = "开票金额不能为空！";
            }
          });

        }
        if (this.form.sign === "销售") {
          if (this.deliveryList > 0 || this.saleOrderList > 0) {
            return this.$message.error("存在未开票的行项目！");
          }
          if (this.form.details.length > 0) {
            this.form.details.forEach((item) => {
              if (item.type === "汇总") {
                let deliveryList = [];
                let saleOrderList = [];
                item.countList.forEach((item2) => {
                  if (item2.type === "销售订单") {
                    saleOrderList.push(item2);
                  } else {
                    deliveryList.push(item2);
                  }
                });
                item.deliveryList = deliveryList;
                item.saleOrderList = saleOrderList;
              }
            });
          }
        }
        this.countInvoiceTotalAmount();
        if (isNext) {
          console.log("请求接口！");
          this.$http.post("basic", "invoiceApplications", this.form)
            .then(() => {
              // 关闭标签
              this.$bus.$emit("closeTag", this.$route);
              this.$router.push({
                path: "/SalesManage/InvoiceApplication/ToDoInvoiceList",
              });
            }).catch(() => {
              this.$message.error("保存失败");
              this.submitLoading = false;
            });
        } else {
          return this.$message.error(message);
        }
      },
      submit() {
        console.log(this.form);
        // this.$http.post("basic", "invoiceApplications/saveAndSubmit", this.form)
        //   .then(() => {
        //     // 关闭标签
        //     this.$bus.$emit("closeTag", this.$route);
        //     this.$router.push({
        //       path: "/SalesManage/InvoiceApplication/ToDoInvoiceList",
        //     });
        //   }).catch(() => {
        //     this.$message.error("保存失败");
        //     this.submitLoading = false;
        //   });
      },
      selectCustomerName(row) {
        this.form.customerId = row.customerID;
        this.form.customerName = row.customerName;
        this.form.customerNo = row.outerNo;
        this.form.invoiceVATNO = row.vatno;
        this.form.invoiceAccounts = row.accounts;
        this.form.invoiceAddress = row.address;
        this.form.email = row.email;
      },
      addFinancialDetails() {
        console.log(111);
        let obj = {
          invoiceContent: "",
          materialNo: "",
          materialName: "",
          specification: "",
          unit: "",
          quantity: "",
          unitPrice: "",
          totalPrice: "",
          note: "",
          rowIndex: "",
          type: "",
          deliveryBillId: "",
          deliveryDetailId: "",
          billNo: "",
        };
        this.form.details.push(obj);
        console.log(this.form.details);
      },
      handleTypeChange(row) {
        // console.log("11111111111111");
        // console.log(row);
        row.totalPrice = row.quantity * row.unitPrice;
        //计算总金额
        let invoiceTotalAmount = 0;
        this.form.details.forEach((item) => {
          invoiceTotalAmount += parseFloat(item.totalPrice);
        });
        this.form.invoiceTotalAmount = invoiceTotalAmount;
        console.log(invoiceTotalAmount);
      },
      handleTypeDetailChange(row) {
        row.totalPrice = row.quantity * row.unitPrice;
      },
      countInvoiceTotalAmount() {
        //计算总金额
        let invoiceTotalAmount = 0;
        this.form.details.forEach((item) => {
          invoiceTotalAmount += parseFloat(item.totalPrice);
        });
        this.form.invoiceTotalAmount = invoiceTotalAmount;
      },
    },
  };
</script>
<style lang="scss" scoped>
.ReserveOrderTable {
  font-family: verdana, arial, sans-serif;
  font-size: 13px;
  color: #333333;
  border-left: 1px solid #dddddd;
  border-bottom: 1px solid #dddddd;
}

.ReserveOrderTable td {
  padding: 5px;
  border-right: 1px solid #dddddd;
  border-top: 1px solid #dddddd;
}

.title {
  font-size: 16px;
  border-bottom: 1px solid #ccc;
  width: 100%;
  margin: 10px 0 5px;
}

.tableLabel {
  width: 240px;
  text-align: left;
  background-color: #D1E6F5;
}

.tableContent {
  width: 340px;
  text-align: left;
  white-space: pre-wrap;
}

.detailTableLabel {
  width: 100px;
  text-align: left;
  background-color: #D1E6F5;
}


</style>